export function pick<T, K extends keyof T>(object: T, keys: K[]) {
  return keys.reduce(
    (result, key) => {
      result[key] = object[key];
      return result;
    },
    {} as Pick<T, K>,
  );
}

export function omit<T extends object, K extends keyof T>(object: T, keys: K[]): Omit<T, K> {
  const stringKeys = new Set(keys.map(String));
  const savedKeys = Object.keys(object).filter((key) => !stringKeys.has(key)) as Exclude<keyof T, K>[];

  return pick(object, savedKeys);
}
